import {TFunction} from 'i18next';
import {MatrixEvent} from 'matrix-js-sdk';

import {isSystemMessage} from '@/components/matrix-chat/utils/helper-functions';
import {getEventText, getSystemMessageText} from '.';

export const getText = (
  event: MatrixEvent,
  t: TFunction,
  senderName?: string,
  isDirect?: boolean
): string | null => {
  if (isSystemMessage(event)) {
    return getSystemMessageText(event, t, senderName, isDirect);
  }
  return getEventText(event, t);
};
